import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { FlagIcon } from './UI';
export const Footer = () => {
  const [showShippingPolicy, setShowShippingPolicy] = useState(false);
  const [showWarrantyPolicy, setShowWarrantyPolicy] = useState(false);
  const [showReturnsPolicy, setShowReturnsPolicy] = useState(false);
  const [showContactPolicy, setShowContactPolicy] = useState(false);
  const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
  const [showTermsPolicy, setShowTermsPolicy] = useState(false);
  const [showMission, setShowMission] = useState(false);
  const [showWhyWeBuilt, setShowWhyWeBuilt] = useState(false);
  const [showWholesale, setShowWholesale] = useState(false);
  return <footer className="bg-[#0a0a0a] border-t border-dark-3" data-id="element-179" data-mp="3qf9q4ni5awfs">
      {/* Shipping Policy Modal */}
      <AnimatePresence data-id="element-180" data-mp="2a1jkvdfai24k">
        {showShippingPolicy && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" data-id="element-181" data-mp="2ez1l8ff8r90y">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setShowShippingPolicy(false)} className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-182" data-mp="3lalkbra34rzr" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative w-full max-w-3xl max-h-[85vh] bg-dark-1 border border-dark-3 shadow-2xl flex flex-col" data-id="element-183" data-mp="82icpt2wkaeu">
              {/* Modal Header */}
              <div className="flex items-center justify-between p-6 border-b border-dark-3 bg-base-black" data-id="element-184" data-mp="mptp1x6wryg0">
                <h2 className="font-bebas text-3xl text-white tracking-wider" data-id="element-185" data-mp="tt0bcx16uytn">
                  SHIPPING POLICY
                </h2>
                <button onClick={() => setShowShippingPolicy(false)} className="text-text-dimmed hover:text-acid-green transition-colors" data-id="element-186" data-mp="13sr1ynmmotog">
                  <X size={24} data-id="element-187" data-mp="1clumffvoy6sl" />
                </button>
              </div>

              {/* Modal Body */}
              <div className="p-6 overflow-y-auto font-inter text-sm text-text-dimmed leading-relaxed space-y-6 custom-scrollbar" data-id="element-188" data-mp="1hk5vvpi2qfaa">
                <p data-id="element-189" data-mp="1mkbk0vp4xjnm">
                  <strong data-id="element-190" data-mp="1mhpawrmliw3a">Effective Date:</strong> May 18, 2024
                </p>
                <p data-id="element-191" data-mp="1rid3hhqh3kzm">
                  Welcome to BLACKOUT UNIT. This Shipping Policy explains how
                  orders are processed, shipped, and delivered when you purchase
                  from our store. By placing an order with BLACKOUT UNIT, you
                  agree to the terms below.
                </p>

                <div data-id="element-192" data-mp="2agye35m7ixo8">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-193" data-mp="25onczzfqd5u3">
                    ORDER PROCESSING
                  </h3>
                  <ul className="list-disc pl-5 space-y-2" data-id="element-194" data-mp="21nv2l2v4guw8">
                    <li data-id="element-195" data-mp="1wnpaxmour8e5">
                      All orders are processed within 24 hours after the order
                      is successfully placed and payment is verified.
                    </li>
                    <li data-id="element-196" data-mp="2pceavie697ob">
                      Orders placed after business hours, on weekends, or on
                      holidays may be processed on the next business day.
                    </li>
                  </ul>
                  <p className="mt-2" data-id="element-197" data-mp="2fezvzn7wcqy4">Please note:</p>
                  <ul className="list-disc pl-5 space-y-2" data-id="element-198" data-mp="2fgayzktipuo6">
                    <li data-id="element-199" data-mp="18z63189psxml">
                      Processing time is separate from shipping transit time.
                    </li>
                    <li data-id="element-200" data-mp="13xqeh68bw8zg">
                      Orders may be delayed for fraud prevention review, payment
                      verification, inventory checks, or address confirmation.
                    </li>
                    <li data-id="element-201" data-mp="2wok9rw7abko9">
                      BLACKOUT UNIT reserves the right to cancel or hold any
                      order suspected of fraud or unauthorized activity.
                    </li>
                  </ul>
                </div>

                <div data-id="element-202" data-mp="3bjgrd00zhke0">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-203" data-mp="3bl1maqr7n5ce">
                    SHIPPING TIMEFRAME
                  </h3>
                  <ul className="list-disc pl-5 space-y-2" data-id="element-204" data-mp="3fizd1y0mpzhw">
                    <li data-id="element-205" data-mp="31kr7x2tfvrvn">Orders are shipped via USPS.</li>
                    <li data-id="element-206" data-mp="36kdlxeh3dc5i">
                      Estimated delivery time is typically 3–5 business days
                      after the order has been processed and shipped.
                    </li>
                  </ul>
                  <p className="mt-2" data-id="element-207" data-mp="1v5qmvs5ycu3u">
                    Please understand that shipping timelines are estimates only
                    and are not guaranteed. Delivery times may be affected by:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-208" data-mp="1im32c80jt5cj">
                    <li data-id="element-209" data-mp="1wmdynqkmnc53">Carrier delays</li>
                    <li data-id="element-210" data-mp="1wm43zpon0gt2">Weather conditions</li>
                    <li data-id="element-211" data-mp="1rnstdcqiq29s">High shipping volume</li>
                    <li data-id="element-212" data-mp="1ro2lp6z1clin">Holidays</li>
                    <li data-id="element-213" data-mp="1rlq2kqhjk540">Customs processing</li>
                    <li data-id="element-214" data-mp="13z0582g50ypq">Natural disasters</li>
                    <li data-id="element-215" data-mp="13vm1aprtshg6">Incorrect shipping information</li>
                    <li data-id="element-216" data-mp="zxobplu57tc9">Circumstances outside of our control</li>
                  </ul>
                  <p className="mt-2" data-id="element-217" data-mp="1dotgt3ga5dtz">
                    BLACKOUT UNIT is not responsible for delays caused by USPS
                    or other carrier-related issues once the package has been
                    shipped.
                  </p>
                </div>

                <div data-id="element-218" data-mp="g8noq36tttnj">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-219" data-mp="g95txpbgvi7l">
                    TRACKING INFORMATION
                  </h3>
                  <ul className="list-disc pl-5 space-y-2" data-id="element-220" data-mp="2gadgsa4437sg">
                    <li data-id="element-221" data-mp="2l8yjqhar05kl">
                      Tracking information will be sent to the email provided at
                      checkout once the order has shipped.
                    </li>
                    <li data-id="element-222" data-mp="2v01hpa8ds4fn">
                      Please allow up to 24 hours for tracking updates to appear
                      within the carrier’s system.
                    </li>
                  </ul>
                </div>

                <div data-id="element-223" data-mp="22bnkgwp49c55">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-224" data-mp="22b4ca7p9q24b">
                    SHIPPING ADDRESS RESPONSIBILITY
                  </h3>
                  <p data-id="element-225" data-mp="2bc26xzdtgxa8">
                    Customers are responsible for entering the correct shipping
                    address at checkout. BLACKOUT UNIT is not responsible for:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-226" data-mp="3mq6a9w6anxry">
                    <li data-id="element-227" data-mp="3msk4k2t5h5yg">Incorrect addresses entered by customers</li>
                    <li data-id="element-228" data-mp="1b2ugoy19s7rl">Failed deliveries</li>
                    <li data-id="element-229" data-mp="171r3ykeiqrul">Returned shipments</li>
                    <li data-id="element-230" data-mp="17322o5t3x9eu">
                      Packages delivered to the address provided during checkout
                    </li>
                  </ul>
                  <p className="mt-2" data-id="element-231" data-mp="xc7gf1fv29te">
                    If a package is returned due to an incorrect or insufficient
                    address, additional shipping charges may apply before
                    reshipment.
                  </p>
                </div>

                <div data-id="element-232" data-mp="nfw1s4sst7vs">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-233" data-mp="jc6inuuw7ii5">
                    LOST, STOLEN, OR DELIVERED PACKAGES
                  </h3>
                  <p data-id="element-234" data-mp="eeen8qv1he97">
                    Once a package has been transferred to USPS and marked as
                    shipped, BLACKOUT UNIT is no longer responsible for
                    carrier-related delivery issues. BLACKOUT UNIT is not liable
                    for:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-235" data-mp="1hn37mjndtq0m">
                    <li data-id="element-236" data-mp="1mld36vd0qsmr">Lost packages</li>
                    <li data-id="element-237" data-mp="1mkbuuyne0k8q">Stolen packages</li>
                    <li data-id="element-238" data-mp="17w8kze684oen">Delayed packages</li>
                    <li data-id="element-239" data-mp="17v5sx2x60fx5">Packages marked as “Delivered”</li>
                    <li data-id="element-240" data-mp="1cus65ccztw5y">Carrier mishandling</li>
                  </ul>
                  <p className="mt-2" data-id="element-241" data-mp="1csz3e85i3w38">
                    Customers must contact USPS directly regarding delivery
                    disputes or carrier claims.
                  </p>
                </div>

                <div data-id="element-242" data-mp="12ujb41uqmgs5">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-243" data-mp="oxmka0emczb9">
                    SHIPPING FEES
                  </h3>
                  <p data-id="element-244" data-mp="tx8zughx6rn8">
                    Shipping fees are calculated at checkout and are
                    non-refundable once the order has shipped.
                  </p>
                </div>

                <div data-id="element-245" data-mp="2o95q464mlrgp">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-246" data-mp="2o9fk04sskiro">
                    INTERNATIONAL SHIPPING
                  </h3>
                  <p data-id="element-247" data-mp="7nsbwimj1u2r">If international shipping is offered:</p>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-248" data-mp="7plo0dfwt6i5">
                    <li data-id="element-249" data-mp="mcx14jrqoykd">
                      Customers are responsible for all customs duties, taxes,
                      import fees, and VAT charges.
                    </li>
                    <li data-id="element-250" data-mp="vctrqqxow7i2">
                      BLACKOUT UNIT is not responsible for customs delays or
                      seizures.
                    </li>
                  </ul>
                </div>

                <div data-id="element-251" data-mp="15c2gn5dp6vxk">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-252" data-mp="15ahk5a7tp2x2">
                    REFUSED OR RETURNED SHIPMENTS
                  </h3>
                  <p data-id="element-253" data-mp="10alj9juf9rlq">
                    If an order is refused, unclaimed, or returned to sender,
                    BLACKOUT UNIT reserves the right to deduct:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-254" data-mp="325vwdzhfj6mw">
                    <li data-id="element-255" data-mp="iv9v0rvynzcg">Original shipping costs</li>
                    <li data-id="element-256" data-mp="dv5fb42vn8na">Return shipping fees</li>
                    <li data-id="element-257" data-mp="duch4rhzhrgr">Restocking fees (if applicable)</li>
                  </ul>
                  <p className="mt-2" data-id="element-258" data-mp="8v9bp5y3dj89">before issuing any refund.</p>
                </div>

                <div data-id="element-259" data-mp="3xhi87hstp1y">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-260" data-mp="3y0zrn3jebfg">
                    LIMITATION OF LIABILITY
                  </h3>
                  <p data-id="element-261" data-mp="11msx8wi5v9df">
                    To the fullest extent permitted by law, BLACKOUT UNIT shall
                    not be liable for:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-262" data-mp="rtlxbr66wlkq">
                    <li data-id="element-263" data-mp="mw3ixl9ele5c">Shipping delays</li>
                    <li data-id="element-264" data-mp="mvampe82m71g">Carrier errors</li>
                    <li data-id="element-265" data-mp="1kb7q7pc1gxgv">Delivery failures</li>
                    <li data-id="element-266" data-mp="1kbznd4lab399">Lost profits</li>
                    <li data-id="element-267" data-mp="1kd2dvbep33on">Indirect or consequential damages</li>
                    <li data-id="element-268" data-mp="1fjpr76tkt6yj">Events beyond our reasonable control</li>
                  </ul>
                  <p className="mt-2" data-id="element-269" data-mp="1nu6tm5wr65r2">
                    Our maximum liability shall never exceed the purchase price
                    of the product ordered.
                  </p>
                </div>

                <div data-id="element-270" data-mp="1wt225on9rrxj">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-271" data-mp="1wsikm91j75k1">
                    POLICY CHANGES
                  </h3>
                  <p data-id="element-272" data-mp="26rzl8c1xet95">
                    BLACKOUT UNIT reserves the right to update or modify this
                    Shipping Policy at any time without prior notice.
                  </p>
                </div>

                <div data-id="element-273" data-mp="2fjt6gbsegs52">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-274" data-mp="2flcni4lvr77w">
                    CONTACT
                  </h3>
                  <p data-id="element-275" data-mp="2kiw95pkwqm9v">
                    BLACKOUT UNIT Customer Support:{' '}
                    <a href="mailto:support@blackoutunit.com" className="text-acid-green hover:underline" data-id="element-276" data-mp="2pjk4uok2zraf">
                      support@blackoutunit.com
                    </a>
                  </p>
                </div>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>

      {/* Warranty Policy Modal */}
      <AnimatePresence data-id="element-277" data-mp="2eksx4upvek9x">
        {showWarrantyPolicy && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" data-id="element-278" data-mp="29rzss7ybddyd">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setShowWarrantyPolicy(false)} className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-279" data-mp="2njo62ekau8gx" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative w-full max-w-3xl max-h-[85vh] bg-dark-1 border border-dark-3 shadow-2xl flex flex-col" data-id="element-280" data-mp="2sh6gk9dysvr1">
              {/* Modal Header */}
              <div className="flex items-center justify-between p-6 border-b border-dark-3 bg-base-black" data-id="element-281" data-mp="350bt5zncghul">
                <h2 className="font-bebas text-3xl text-white tracking-wider" data-id="element-282" data-mp="2r0aftkpw7hy8">
                  WARRANTY POLICY
                </h2>
                <button onClick={() => setShowWarrantyPolicy(false)} className="text-text-dimmed hover:text-acid-green transition-colors" data-id="element-283" data-mp="2v145ojmwb6tr">
                  <X size={24} data-id="element-284" data-mp="2m4v7176qsc8o" />
                </button>
              </div>

              {/* Modal Body */}
              <div className="p-6 overflow-y-auto font-inter text-sm text-text-dimmed leading-relaxed space-y-6 custom-scrollbar" data-id="element-285" data-mp="kbdze3im3bdx">
                <p data-id="element-286" data-mp="2gesgt6qrnytn">
                  <strong data-id="element-287" data-mp="2gd923kkrdvtz">Effective Date:</strong> May 18, 2026
                </p>
                <p data-id="element-288" data-mp="2bf7eqngavacp">
                  At BLACKOUT UNIT, we stand behind the quality of our products
                  and are committed to ensuring customer satisfaction. This
                  Warranty Policy outlines the terms, limitations, and
                  conditions applicable to products purchased through our
                  website.
                </p>
                <p data-id="element-289" data-mp="1soy6owxu0od3">
                  By purchasing from BLACKOUT UNIT, you acknowledge and agree to
                  the terms set forth below.
                </p>

                <div data-id="element-290" data-mp="1nq4patffcd7n">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-291" data-mp="1nnin79baypwt">
                    LIMITED PRODUCT WARRANTY
                  </h3>
                  <ul className="list-disc pl-5 space-y-2" data-id="element-292" data-mp="1epges8p8ouzi">
                    <li data-id="element-293" data-mp="19q3pziet5dua">
                      BLACKOUT UNIT provides a limited warranty covering
                      manufacturing defects in materials or workmanship under
                      normal and intended use.
                    </li>
                    <li data-id="element-294" data-mp="3qbh12x1m0v40">
                      This warranty applies only to the original purchaser and
                      only to products purchased directly from BLACKOUT UNIT or
                      our authorized sales channels.
                    </li>
                  </ul>
                </div>

                <div data-id="element-295" data-mp="32o8xcjjtxu43">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-296" data-mp="32kuw5emwjqy8">
                    WARRANTY PERIOD
                  </h3>
                  <p data-id="element-297" data-mp="3bnw2ngfojk2f">
                    Unless otherwise stated on the product page, the standard
                    warranty period is:
                  </p>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-298" data-mp="3gfniox17m7eb">
                    <li data-id="element-299" data-mp="2jveugnzhdsg8">30 days from the date of delivery</li>
                  </ul>
                  <p className="mt-2" data-id="element-300" data-mp="2nxjjtaiwc2x2">
                    The warranty period begins on the date the carrier marks the
                    package as delivered.
                  </p>
                </div>

                <div data-id="element-301" data-mp="3manucw66e2zx">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-302" data-mp="3m92zf5fy8i1j">
                    WHAT IS COVERED
                  </h3>
                  <p data-id="element-303" data-mp="4vgyx94ybaqr">This limited warranty covers:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-304" data-mp="3w0qk8ni030u1">
                    <li data-id="element-305" data-mp="38a36vmpbfj03">Manufacturing defects</li>
                    <li data-id="element-306" data-mp="38awboi4pryfl">Defective materials</li>
                    <li data-id="element-307" data-mp="33b06ifka60yg">Workmanship defects under normal use</li>
                    <li data-id="element-308" data-mp="33cuobl099cyb">Product failures caused by verified factory defects</li>
                  </ul>
                  <p className="mt-2" data-id="element-309" data-mp="3hc478sfuil5z">
                    If BLACKOUT UNIT determines that a product qualifies under
                    this warranty, we may, at our sole discretion:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-310" data-mp="wmn443zj3ymw">
                    <li data-id="element-311" data-mp="si70689h71ab">Repair the item</li>
                    <li data-id="element-312" data-mp="slba7m9mgr8w">Replace the item</li>
                    <li data-id="element-313" data-mp="101gac3pt340f">Issue store credit</li>
                    <li data-id="element-314" data-mp="104udvfa7hj9g">Issue a partial or full refund</li>
                  </ul>
                </div>

                <div data-id="element-315" data-mp="14z83f126sw67">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-316" data-mp="q4k27z3tkjwe">
                    WHAT IS NOT COVERED
                  </h3>
                  <p data-id="element-317" data-mp="v46cbzocpk0z">This warranty does not cover:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-318" data-mp="1iszfoh7ayu5m">
                    <li data-id="element-319" data-mp="1itr7dgxs47qm">Normal wear and tear</li>
                    <li data-id="element-320" data-mp="1nslnuc89xk7k">Cosmetic damage</li>
                    <li data-id="element-321" data-mp="1nramej2awojm">Scratches, dents, fading, or discoloration</li>
                    <li data-id="element-322" data-mp="1924qb3yrfefy">
                      Damage caused by misuse, abuse, accidents, negligence, or
                      improper handling
                    </li>
                    <li data-id="element-323" data-mp="21s3k1cnwfzqy">Improper washing, maintenance, or storage</li>
                    <li data-id="element-324" data-mp="21pqtib42sh2a">Unauthorized modifications or alterations</li>
                    <li data-id="element-325" data-mp="26jbsa5dhtf2j">
                      Damage caused during shipping by third-party carriers
                    </li>
                    <li data-id="element-326" data-mp="6iez6d8xdm57">Products used outside their intended purpose</li>
                    <li data-id="element-327" data-mp="1osmwm6obk9x">Loss, theft, or accidental damage</li>
                    <li data-id="element-328" data-mp="3tt4trlxqyf79">
                      Customer dissatisfaction related to sizing, fit, or
                      personal preference
                    </li>
                    <li data-id="element-329" data-mp="3os75qsq22qxu">Products marked as Final Sale or Clearance</li>
                  </ul>
                  <p className="mt-2" data-id="element-330" data-mp="pd2ds2iquy7x">
                    BLACKOUT UNIT reserves the right to determine whether damage
                    is the result of a manufacturing defect or external causes.
                  </p>
                </div>

                <div data-id="element-331" data-mp="bfx13joiz13p">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-332" data-mp="bec7pxdy5o7f">
                    WARRANTY CLAIM PROCESS
                  </h3>
                  <p data-id="element-333" data-mp="312mk222ipfkv">
                    To submit a warranty claim, customers must contact BLACKOUT
                    UNIT within the applicable warranty period.
                  </p>
                  <p className="mt-2" data-id="element-334" data-mp="2m3invx46uadk">Claims must include:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-335" data-mp="2qzza2lrtueo0">
                    <li data-id="element-336" data-mp="2vzvjx1n7h0bh">Full name</li>
                    <li data-id="element-337" data-mp="2vyu4kkz5prny">Order number</li>
                    <li data-id="element-338" data-mp="2vxsillglrkrg">Description of the issue</li>
                    <li data-id="element-339" data-mp="30rnavda9x825">Clear photographs or videos showing the defect</li>
                    <li data-id="element-340" data-mp="34sfik23hz4wb">Proof of purchase</li>
                  </ul>
                  <p className="mt-2" data-id="element-341" data-mp="34u9tqooyvin7">
                    Failure to provide sufficient documentation may result in
                    denial of the claim.
                  </p>
                </div>

                <div data-id="element-342" data-mp="3eoaaxoxiweca">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-343" data-mp="3jp6bbsio1icy">
                    CLAIM REVIEW PROCESS
                  </h3>
                  <p data-id="element-344" data-mp="1kddlqgy7jfa9">
                    All warranty claims are subject to inspection and approval
                    by BLACKOUT UNIT.
                  </p>
                  <p className="mt-2" data-id="element-345" data-mp="3tfgr8gjr7aqr">BLACKOUT UNIT reserves the right to:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-346" data-mp="3tddwxkbkivg8">
                    <li data-id="element-347" data-mp="1chdqbs8ihvx">Request additional evidence</li>
                    <li data-id="element-348" data-mp="6b102daqpvot">Deny claims lacking sufficient proof</li>
                    <li data-id="element-349" data-mp="69g18bhe7ql5">Require return of the product for inspection</li>
                    <li data-id="element-350" data-mp="b299vafzfj2i">
                      Determine the appropriate resolution at its sole
                      discretion
                    </li>
                  </ul>
                  <p className="mt-2" data-id="element-351" data-mp="kz5gtbq8fx4y">
                    Submitting a claim does not guarantee approval.
                  </p>
                </div>

                <div data-id="element-352" data-mp="oz5xz44pumfp">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-353" data-mp="u0d3sxnatbjq">
                    SHIPPING COSTS FOR WARRANTY CLAIMS
                  </h3>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-354" data-mp="2qtx2wurvkrg1">
                    <li data-id="element-355" data-mp="2vr6pm2nvqp06">
                      Customers may be responsible for shipping costs associated
                      with warranty claims unless prohibited by applicable law.
                    </li>
                    <li data-id="element-356" data-mp="2jh7agv31clfw">Original shipping charges are non-refundable.</li>
                  </ul>
                </div>

                <div data-id="element-357" data-mp="2ej5skdhcis60">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-358" data-mp="2einncrcph3ly">
                    LIMITATION OF LIABILITY
                  </h3>
                  <p data-id="element-359" data-mp="376t83e3resls">
                    To the fullest extent permitted by law, BLACKOUT UNIT shall
                    not be liable for:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-360" data-mp="328ruh8p3rlhp">
                    <li data-id="element-361" data-mp="2x7ubwv06kpfo">Indirect damages</li>
                    <li data-id="element-362" data-mp="2xaq9gi849c3l">Consequential damages</li>
                    <li data-id="element-363" data-mp="2t68qumdht4ue">Incidental damages</li>
                    <li data-id="element-364" data-mp="2t9mtlvq2jg2d">Loss of use</li>
                    <li data-id="element-365" data-mp="1ltywdl5d6enx">Loss of profits</li>
                    <li data-id="element-366" data-mp="1lv1mhquv4d2s">Third-party damages</li>
                  </ul>
                  <p className="mt-2" data-id="element-367" data-mp="1hr25z89l1e9f">
                    BLACKOUT UNIT’s total liability shall never exceed the
                    original purchase price paid for the product.
                  </p>
                </div>

                <div data-id="element-368" data-mp="1o7lwo0yht850">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-369" data-mp="1o611qa89nn6m">
                    NO OTHER WARRANTIES
                  </h3>
                  <p data-id="element-370" data-mp="1e9eitqzi3678">
                    Except as expressly stated herein, BLACKOUT UNIT makes no
                    additional warranties, express or implied, including but not
                    limited to:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-371" data-mp="15b2igx8u0u1l">
                    <li data-id="element-372" data-mp="qlehjx4kbxee">Merchantability</li>
                    <li data-id="element-373" data-mp="qmg2ctbdry9b">Fitness for a particular purpose</li>
                    <li data-id="element-374" data-mp="vkrfbcwz2ovr">Non-infringement</li>
                  </ul>
                </div>

                <div data-id="element-375" data-mp="hjoqiself0h5">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-376" data-mp="hl860gsfd7hv">
                    CHARGEBACK ABUSE & FRAUD
                  </h3>
                  <p data-id="element-377" data-mp="lnd01gmsc651">
                    Any fraudulent warranty claim, abuse of refund systems, or
                    unauthorized chargeback related to a valid order may result
                    in:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-378" data-mp="byfro6lctb1s">
                    <li data-id="element-379" data-mp="bvtoej5hxhpd">Permanent account restriction</li>
                    <li data-id="element-380" data-mp="6xs11m11ew83">Refusal of future service</li>
                    <li data-id="element-381" data-mp="lw40u1jpil3h">
                      Submission to collections or legal review where applicable
                    </li>
                  </ul>
                </div>

                <div data-id="element-382" data-mp="gwr50rauy3or">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-383" data-mp="uoeanhqowok7">
                    POLICY CHANGES
                  </h3>
                  <p data-id="element-384" data-mp="qmkcph7vpynq">
                    BLACKOUT UNIT reserves the right to modify or update this
                    Warranty Policy at any time without prior notice.
                  </p>
                </div>

                <div data-id="element-385" data-mp="zojuibqpx6rq">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-386" data-mp="zpbs1s3vlekn">
                    CONTACT INFORMATION
                  </h3>
                  <p data-id="element-387" data-mp="1nr6yvun9bbij">
                    BLACKOUT UNIT Customer Support Department:{' '}
                    <a href="mailto:support@blackoutunit.com" className="text-acid-green hover:underline" data-id="element-388" data-mp="1nou9iwf65yvg">
                      support@blackoutunit.com
                    </a>
                  </p>
                </div>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>

      {/* Returns Policy Modal */}
      <AnimatePresence data-id="element-389" data-mp="19rfi5m5cvh0u">
        {showReturnsPolicy && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" data-id="element-390" data-mp="19pun7vf4pw2g">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setShowReturnsPolicy(false)} className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-391" data-mp="1es3f0og9ms2z" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative w-full max-w-3xl max-h-[85vh] bg-dark-1 border border-dark-3 shadow-2xl flex flex-col" data-id="element-392" data-mp="9kabalzghmdy">
              {/* Modal Header */}
              <div className="flex items-center justify-between p-6 border-b border-dark-3 bg-base-black" data-id="element-393" data-mp="3i0vnscraqxlt">
                <h2 className="font-bebas text-3xl text-white tracking-wider" data-id="element-394" data-mp="1g7pbg66w61gp">
                  RETURNS & EXCHANGES POLICY
                </h2>
                <button onClick={() => setShowReturnsPolicy(false)} className="text-text-dimmed hover:text-acid-green transition-colors" data-id="element-395" data-mp="1b9w8dm0vxnkn">
                  <X size={24} data-id="element-396" data-mp="3agl26bq1g6dg" />
                </button>
              </div>

              {/* Modal Body */}
              <div className="p-6 overflow-y-auto font-inter text-sm text-text-dimmed leading-relaxed space-y-6 custom-scrollbar" data-id="element-397" data-mp="2vrybjduyns6x">
                <p data-id="element-398" data-mp="30nni415ee9cq">
                  <strong data-id="element-399" data-mp="3ofaxpmx7lxzp">Effective Date:</strong> May 18, 2026
                </p>
                <p data-id="element-400" data-mp="3odhsmc28vltt">
                  At BLACKOUT UNIT, all purchases are subject to the terms
                  outlined in this Returns & Exchanges Policy. Due to the nature
                  of our products, limited inventory releases, promotional
                  pricing, discounted offers, and hygiene/safety considerations,
                  all sales are considered final unless otherwise stated below.
                </p>
                <p data-id="element-401" data-mp="281kjhncdltcc">
                  By placing an order with BLACKOUT UNIT, the customer
                  acknowledges and agrees to this policy in full.
                </p>

                <div data-id="element-402" data-mp="1vigskh5zihew">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-403" data-mp="1viypzh4dv1oe">
                    ALL SALES ARE FINAL
                  </h3>
                  <p data-id="element-404" data-mp="2af7kk5dbwquh">
                    Due to the nature of our products, including tactical gear,
                    face coverings, accessories, promotional inventory,
                    discounted products, and limited releases, ALL SALES ARE
                    FINAL.
                  </p>
                  <p className="mt-2" data-id="element-405" data-mp="1ctiksghr6l1n">
                    BLACKOUT UNIT does not guarantee refunds, exchanges, or
                    returns for:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-406" data-mp="1mpvbr6lwyksp">
                    <li data-id="element-407" data-mp="z0kkcfqge2r8">Buyer’s remorse</li>
                    <li data-id="element-408" data-mp="yziyrhbt9xv9">Incorrect size selection</li>
                    <li data-id="element-409" data-mp="u1he4ryqlqho">Personal preference</li>
                    <li data-id="element-410" data-mp="u0eloflrnfzn">Change of mind</li>
                    <li data-id="element-411" data-mp="tzn2y5d9pcqs">Delayed carrier delivery</li>
                    <li data-id="element-412" data-mp="8j6f0mbv5k4x">Refused shipments</li>
                    <li data-id="element-413" data-mp="8khkcqkyizy5">Incorrect addresses entered by the customer</li>
                  </ul>
                  <p className="mt-2" data-id="element-414" data-mp="djc1zp76uigo">
                    Products purchased during promotions, discount campaigns,
                    clearance events, coupon offers, or limited releases are
                    considered Final Sale and are non-refundable.
                  </p>
                </div>

                <div data-id="element-415" data-mp="rf68y2oeixr5">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-416" data-mp="wftwgedf8wgm">
                    RETURN EXCEPTIONS
                  </h3>
                  <p data-id="element-417" data-mp="1184z3ozjqwcv">A return or replacement may only be considered if:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-418" data-mp="166eu9zl9twyh">
                    <li data-id="element-419" data-mp="167pzm3ud7crp">The wrong item was shipped by BLACKOUT UNIT</li>
                    <li data-id="element-420" data-mp="1a9368g5a7jzo">
                      The product arrives with a verified manufacturing defect
                    </li>
                    <li data-id="element-421" data-mp="1f48n30jtu8gw">
                      The item arrives physically damaged due to a verified
                      fulfillment error
                    </li>
                  </ul>
                  <p className="mt-2" data-id="element-422" data-mp="2urnhc1vdtr9p">
                    All claims must be submitted within 48 hours of delivery.
                    Claims submitted after this period may be denied.
                  </p>
                </div>

                <div data-id="element-423" data-mp="3ievjwc1fem81">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-424" data-mp="3ie298zzcjckm">
                    CLAIM REQUIREMENTS
                  </h3>
                  <p data-id="element-425" data-mp="3eebmd7cxxgld">
                    To request review of a damaged or incorrect order, the
                    customer must provide:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-426" data-mp="34oibk8kmh5i6">
                    <li data-id="element-427" data-mp="5xqbtm4nufg5">Full name</li>
                    <li data-id="element-428" data-mp="5yrxekjaykc4">Order number</li>
                    <li data-id="element-429" data-mp="5ztbkxvm7my2">Clear photographs of the item</li>
                    <li data-id="element-430" data-mp="15ys9vjx99zi">Clear photographs of the packaging</li>
                    <li data-id="element-431" data-mp="3p66b96sjvx8z">Description of the issue</li>
                  </ul>
                  <p className="mt-2" data-id="element-432" data-mp="3p893lxh6e2gv">
                    BLACKOUT UNIT reserves the right to deny any request lacking
                    sufficient evidence.
                  </p>
                </div>

                <div data-id="element-433" data-mp="2wlmdmw857xs">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-434" data-mp="3u5iyhsnc36c3">
                    RETURN AUTHORIZATION REQUIRED
                  </h3>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-435" data-mp="bybmdh469f76">
                    <li data-id="element-436" data-mp="7ykt96r6amzh">
                      No return will be accepted without prior written
                      authorization from BLACKOUT UNIT.
                    </li>
                    <li data-id="element-437" data-mp="gqcx2yloyxv3">
                      Unauthorized returns may be refused or discarded without
                      refund.
                    </li>
                  </ul>
                  <p className="mt-2" data-id="element-438" data-mp="vlj5ttc69as4">
                    Once a return is authorized, approved items must be shipped
                    to:
                  </p>
                  <address className="not-italic mt-2" data-id="element-439" data-mp="1abnj8uod2qyc">
                    BLACKOUT UNIT — Returns
                    <br data-id="element-440" data-mp="1eamm89qj8dn5" />
                    4531 Madison Industrial Lane, Unit 4531
                    <br data-id="element-441" data-mp="10b3dbepwcy9s" />
                    Tampa, FL 33605
                    <br data-id="element-442" data-mp="15b9a19b0xayq" />
                    USA
                  </address>
                </div>

                <div data-id="element-443" data-mp="qmd3xhsj280r">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-444" data-mp="qltktxr55dl5">
                    RETURN SHIPPING COSTS
                  </h3>
                  <p data-id="element-445" data-mp="vemqcnufopya">If a return is exceptionally approved by BLACKOUT UNIT:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-446" data-mp="hmpzso8eyo40">
                    <li data-id="element-447" data-mp="mki4yjy2k6q5">
                      The customer is solely responsible for purchasing the
                      return shipping label
                    </li>
                    <li data-id="element-448" data-mp="7pka9kfg755w">
                      The customer is responsible for all return shipping costs
                    </li>
                    <li data-id="element-449" data-mp="3pn35a9qg883d">
                      Original shipping costs are non-refundable under all
                      circumstances
                    </li>
                  </ul>
                  <p className="mt-2" data-id="element-450" data-mp="3kus3f1c5ec86">
                    Shipping fees paid at checkout are considered completed
                    carrier service charges and will not be refunded.
                  </p>
                </div>

                <div data-id="element-451" data-mp="chcs3o67ntce">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-452" data-mp="cfi769uxw18b">
                    REFUND CONDITIONS
                  </h3>
                  <p data-id="element-453" data-mp="7fnfi43cb7m7">
                    If BLACKOUT UNIT approves a refund at its sole discretion:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-454" data-mp="3toyfy4u9rxtt">
                    <li data-id="element-455" data-mp="3tooqcid4zson">
                      Refunds may be issued as store credit, replacement
                      product, or original payment refund
                    </li>
                    <li data-id="element-456" data-mp="2i903rs3sovod">
                      Refunds will apply only to the product purchase price
                    </li>
                    <li data-id="element-457" data-mp="xpnvws8d2kmh">Original shipping costs will not be refunded</li>
                    <li data-id="element-458" data-mp="12rlmy8n06jpz">Return shipping costs will not be reimbursed</li>
                  </ul>
                  <p className="mt-2" data-id="element-459" data-mp="17p4z93054mfa">
                    BLACKOUT UNIT reserves the right to issue partial refunds
                    where appropriate.
                  </p>
                </div>

                <div data-id="element-460" data-mp="1heybm683x5kl">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-461" data-mp="1hfgc5f1sy5yb">
                    NON-RETURNABLE ITEMS
                  </h3>
                  <p data-id="element-462" data-mp="1qgo136ifhufq">
                    The following items are strictly non-returnable and
                    non-refundable:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-463" data-mp="1vezcvmsaaf0l">
                    <li data-id="element-464" data-mp="3s8knjb64wopa">Tactical masks</li>
                    <li data-id="element-465" data-mp="3s9lxtdfbt75y">Face coverings</li>
                    <li data-id="element-466" data-mp="10ycgxh35jye">Worn merchandise</li>
                    <li data-id="element-467" data-mp="11zyfwzn3quw">Opened products</li>
                    <li data-id="element-468" data-mp="1ribokle9zdls">Clearance items</li>
                    <li data-id="element-469" data-mp="1rhabkbdp8h1f">Promotional items</li>
                    <li data-id="element-470" data-mp="1mjh7bnvyhx3s">Discounted items</li>
                    <li data-id="element-471" data-mp="1mipc4e69u1e1">Limited-release products</li>
                    <li data-id="element-472" data-mp="20j9u584d3t6h">Custom or personalized items</li>
                    <li data-id="element-473" data-mp="20iqdduqg7au1">Gift cards</li>
                    <li data-id="element-474" data-mp="1whomq2alk73o">Hygiene-sensitive products</li>
                  </ul>
                  <p className="mt-2" data-id="element-475" data-mp="1wfk9gtqt5vqq">
                    For health, hygiene, and safety reasons, face-related
                    products and tactical wear cannot be returned once
                    delivered.
                  </p>
                </div>

                <div data-id="element-476" data-mp="1hlfql9m069vh">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-477" data-mp="1hlyvnpqk13s3">
                    CHARGEBACKS & PAYMENT DISPUTES
                  </h3>
                  <p data-id="element-478" data-mp="p43a1w8a06mk">
                    Customers agree not to initiate fraudulent or abusive
                    chargebacks for valid purchases. By completing a purchase
                    with BLACKOUT UNIT, the customer acknowledges that:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-479" data-mp="ax9qsl3iv3p5">
                    <li data-id="element-480" data-mp="fqco94bf6xam">
                      Product descriptions, policies, and checkout terms were
                      reviewed prior to purchase
                    </li>
                    <li data-id="element-481" data-mp="5yyiwfwsf39k">
                      Charges submitted for completed orders are authorized
                    </li>
                    <li data-id="element-482" data-mp="tqdqoo7c2cs7">
                      Shipping and processing timelines are disclosed before
                      checkout
                    </li>
                  </ul>
                  <p className="mt-2" data-id="element-483" data-mp="jro6gorysg8s">
                    Fraudulent disputes, abusive chargebacks, or attempts to
                    retain merchandise while reversing payment may result in:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-484" data-mp="34g2k99qlx8e2">
                    <li data-id="element-485" data-mp="39fynv7ve6xt3">Permanent ban from future purchases</li>
                    <li data-id="element-486" data-mp="39e3zfjkwwnk9">Submission of evidence to the payment processor</li>
                    <li data-id="element-487" data-mp="1fw6gtaq901s5">Collections activity where legally permitted</li>
                    <li data-id="element-488" data-mp="1ay4vej5cnqdi">Civil recovery actions where applicable</li>
                  </ul>
                  <p className="mt-2" data-id="element-489" data-mp="1674yvf057abj">
                    BLACKOUT UNIT reserves all rights to dispute invalid
                    chargebacks with supporting documentation, including
                    tracking confirmation, order records, customer
                    communications, and policy acceptance logs.
                  </p>
                </div>

                <div data-id="element-490" data-mp="s9zx3r7goxm3">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-491" data-mp="n8sr9xovq8i2">
                    LOST, STOLEN, OR DELIVERED PACKAGES
                  </h3>
                  <p data-id="element-492" data-mp="ib0vutp10494">BLACKOUT UNIT is not responsible for:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-493" data-mp="2hnd63tqir9tj">
                    <li data-id="element-494" data-mp="2hkqwlok2ik8o">Lost packages</li>
                    <li data-id="element-495" data-mp="2cnh1bs9zzecx">Stolen packages</li>
                    <li data-id="element-496" data-mp="2cojp3rc0x0om">Carrier delays</li>
                    <li data-id="element-497" data-mp="2k7jc06yp1acq">Packages marked as “Delivered”</li>
                    <li data-id="element-498" data-mp="2k6zswmxb4fx4">Incorrect addresses entered by the customer</li>
                  </ul>
                  <p className="mt-2" data-id="element-499" data-mp="2p4jhafnpy92s">
                    Once the carrier marks a package as delivered,
                    responsibility transfers to the customer.
                  </p>
                </div>

                <div data-id="element-500" data-mp="2yy8kh1krsbcw">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-501" data-mp="218nfgozd4jvq">
                    LIMITATION OF LIABILITY
                  </h3>
                  <p data-id="element-502" data-mp="268jnczb6kvgk">
                    To the fullest extent permitted by law, BLACKOUT UNIT shall
                    not be liable for:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-503" data-mp="2g5ej5ag2khr5">
                    <li data-id="element-504" data-mp="2g3l9dma5thex">Indirect damages</li>
                    <li data-id="element-505" data-mp="3mm9r24ye1hpo">Consequential damages</li>
                    <li data-id="element-506" data-mp="3mlgu1vp8e6kq">Loss of use</li>
                    <li data-id="element-507" data-mp="3rkl38mc5o4b2">Carrier delays</li>
                    <li data-id="element-508" data-mp="3rj9vycji4ef7">Customer misuse</li>
                    <li data-id="element-509" data-mp="gjhjpp9tbw2q">Third-party handling issues</li>
                  </ul>
                  <p className="mt-2" data-id="element-510" data-mp="ghewfd01oh1p">
                    BLACKOUT UNIT’s maximum liability shall never exceed the
                    original purchase price of the product ordered.
                  </p>
                </div>

                <div data-id="element-511" data-mp="liudyv30k5fc">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-512" data-mp="liazjocknz62">
                    POLICY MODIFICATIONS
                  </h3>
                  <p data-id="element-513" data-mp="z860q056dh98">
                    BLACKOUT UNIT reserves the right to modify, update, or
                    revise this policy at any time without prior notice.
                  </p>
                </div>

                <div data-id="element-514" data-mp="1962hb7gvt4eq">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-515" data-mp="149bttz2qz6ja">
                    CONTACT INFORMATION
                  </h3>
                  <p data-id="element-516" data-mp="3b0l0egpxwtrq">
                    BLACKOUT UNIT Customer Support Department:{' '}
                    <a href="mailto:support@blackoutunit.com" className="text-acid-green hover:underline" data-id="element-517" data-mp="3618cdsnc1gnk">
                      support@blackoutunit.com
                    </a>
                  </p>
                </div>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>

      {/* Contact Us Modal */}
      <AnimatePresence data-id="element-518" data-mp="1gqmnggkf1ale">
        {showContactPolicy && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" data-id="element-519" data-mp="12rwpkyprv6vz">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setShowContactPolicy(false)} className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-520" data-mp="17qztugxxh92w" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative w-full max-w-3xl max-h-[85vh] bg-dark-1 border border-dark-3 shadow-2xl flex flex-col" data-id="element-521" data-mp="2n8jkukkhyzl6">
              {/* Modal Header */}
              <div className="flex items-center justify-between p-6 border-b border-dark-3 bg-base-black" data-id="element-522" data-mp="8rhrvx9el795">
                <h2 className="font-bebas text-3xl text-white tracking-wider" data-id="element-523" data-mp="djhyu9nw50f8">
                  CONTACT US
                </h2>
                <button onClick={() => setShowContactPolicy(false)} className="text-text-dimmed hover:text-acid-green transition-colors" data-id="element-524" data-mp="3vyag7kwqx38q">
                  <X size={24} data-id="element-525" data-mp="3lytax4leorda" />
                </button>
              </div>

              {/* Modal Body */}
              <div className="p-6 overflow-y-auto font-inter text-sm text-text-dimmed leading-relaxed space-y-6 custom-scrollbar" data-id="element-526" data-mp="3qwl0hrykw1eb">
                <p data-id="element-527" data-mp="33a91xaz2kui1">
                  At BLACKOUT UNIT, we are committed to providing fast and
                  reliable customer support. If you have any questions regarding
                  your order, shipping, products, or general inquiries, please
                  contact our support team using the information below.
                </p>

                <div data-id="element-528" data-mp="3q944gv7ivihx">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-529" data-mp="3q8catpxhjuua">
                    CUSTOMER SUPPORT
                  </h3>
                  <p data-id="element-530" data-mp="3ukrn2y74bdk">BLACKOUT UNIT Customer Support Department</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-531" data-mp="3wylx9l1xjk2">
                    <li data-id="element-532" data-mp="3v26u4s96i7su">
                      <strong data-id="element-533" data-mp="3v1x9zlateuv2">Email:</strong>{' '}
                      <a href="mailto:support@blackoutunit.com" className="text-acid-green hover:underline" data-id="element-534" data-mp="dsih1trske7r">
                        support@blackoutunit.com
                      </a>
                    </li>
                    <li data-id="element-535" data-mp="kw8818mpo6hh">
                      <strong data-id="element-536" data-mp="kvgmkqmtvp4x">Business Hours:</strong> Monday – Friday 9:00 AM –
                      5:00 PM EST
                    </li>
                  </ul>
                </div>

                <div data-id="element-537" data-mp="ulrrogi904de">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-538" data-mp="un35781hwqhp">
                    MAILING ADDRESS
                  </h3>
                  <address className="not-italic" data-id="element-539" data-mp="zkuvxyqem6kb">
                    BLACKOUT UNIT
                    <br data-id="element-540" data-mp="13leqcujlew2r" />
                    4531 Madison Industrial Lane, Unit 4531
                    <br data-id="element-541" data-mp="18mufoysszoqy" />
                    Tampa, FL 33605
                    <br data-id="element-542" data-mp="1dkvtp5bdgxvk" />
                    USA
                  </address>
                </div>

                <div data-id="element-543" data-mp="3ad5vwgku1bmt">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-544" data-mp="3adz3fjrm8560">
                    RESPONSE TIMES
                  </h3>
                  <p data-id="element-545" data-mp="3fcsivhqgq68t">
                    Our support team typically responds within 24–48 business
                    hours.
                  </p>
                  <p className="mt-2" data-id="element-546" data-mp="332azaq8syi5j">Please note:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-547" data-mp="330gerd1g0s1z">
                    <li data-id="element-548" data-mp="2y253qyzewbi6">
                      Response times may be longer during holidays, weekends,
                      product launches, promotional events, or periods of high
                      order volume.
                    </li>
                    <li data-id="element-549" data-mp="3qqu58z4dqiug">
                      Sending multiple emails regarding the same issue may delay
                      response times.
                    </li>
                  </ul>
                </div>

                <div data-id="element-550" data-mp="3gv8zqr03r0fy">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-551" data-mp="3bul946fsclm9">
                    ORDER SUPPORT
                  </h3>
                  <p data-id="element-552" data-mp="25fbxy2760m1b">For assistance with an existing order, please include:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-553" data-mp="20eoafqi5anbu">
                    <li data-id="element-554" data-mp="20hadpdy06go9">Full name</li>
                    <li data-id="element-555" data-mp="3p8tz0uhpacis">Order number</li>
                    <li data-id="element-556" data-mp="3p82bm6y9bl3l">Email address used at checkout</li>
                    <li data-id="element-557" data-mp="3u0bx9asc9z02">Detailed description of your request</li>
                  </ul>
                  <p className="mt-2" data-id="element-558" data-mp="3fbfotcmdejyx">
                    Providing complete information helps us resolve your request
                    more efficiently.
                  </p>
                </div>

                <div data-id="element-559" data-mp="btxl9hdmrz4b">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-560" data-mp="bvihrcji9s4t">
                    SHIPPING & DELIVERY QUESTIONS
                  </h3>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-561" data-mp="grh6x2cnre6a">
                    <li data-id="element-562" data-mp="1vhtdc6s4ltr">
                      Before contacting support regarding shipping updates,
                      please verify your tracking information first.
                    </li>
                    <li data-id="element-563" data-mp="2mlqq55x4uw0h">
                      Tracking numbers are automatically sent once orders have
                      shipped.
                    </li>
                    <li data-id="element-564" data-mp="19nq5mxbht043">
                      BLACKOUT UNIT is not responsible for carrier delays after
                      packages have been transferred to USPS or the selected
                      shipping carrier.
                    </li>
                  </ul>
                </div>

                <div data-id="element-565" data-mp="1en330bzzppkx">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-566" data-mp="1emjicniygn37">
                    RETURNS & CLAIMS
                  </h3>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-567" data-mp="qy0csfraioet">
                    <li data-id="element-568" data-mp="lyxgpktafsiz">
                      For return requests, damaged item claims, or order issues,
                      customers must contact us within the timeframes outlined
                      in our policies.
                    </li>
                    <li data-id="element-569" data-mp="uxsp93jt1epg">
                      Please include supporting photos and documentation when
                      applicable.
                    </li>
                  </ul>
                </div>

                <div data-id="element-570" data-mp="35tkbroor1ko">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-571" data-mp="22co1iqv7whn8">
                    BUSINESS & COLLABORATION INQUIRIES
                  </h3>
                  <p data-id="element-572" data-mp="27afzo2mggzzv">
                    For partnerships, collaborations, wholesale opportunities,
                    or media inquiries, please contact:{' '}
                    <a href="mailto:business@blackoutunit.com" className="text-acid-green hover:underline" data-id="element-573" data-mp="2h23mfq82hsv0">
                      business@blackoutunit.com
                    </a>
                  </p>
                </div>

                <div data-id="element-574" data-mp="1tc9b5d3ecccv">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-575" data-mp="1tbq2yo3jt2c1">
                    IMPORTANT NOTICE
                  </h3>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-576" data-mp="1ycnj6v4zzmaw">
                    <li data-id="element-577" data-mp="34rxza7sdzhf9">
                      BLACKOUT UNIT reserves the right to refuse service,
                      abusive communications, fraudulent claims, or bad-faith
                      disputes.
                    </li>
                    <li data-id="element-578" data-mp="y2ctgxh2bm0q">
                      Threatening, abusive, defamatory, or fraudulent conduct
                      toward our staff or business may result in termination of
                      communication and refusal of future service.
                    </li>
                  </ul>
                </div>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>

      {/* Privacy Policy Modal */}
      <AnimatePresence data-id="element-579" data-mp="adjsgmll2nz9">
        {showPrivacyPolicy && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" data-id="element-580" data-mp="ac09upcgg0ub">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setShowPrivacyPolicy(false)} className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-581" data-mp="5eqlze4prx8l" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative w-full max-w-3xl max-h-[85vh] bg-dark-1 border border-dark-3 shadow-2xl flex flex-col" data-id="element-582" data-mp="13ou8he5a21eq">
              {/* Modal Header */}
              <div className="flex items-center justify-between p-6 border-b border-dark-3 bg-base-black" data-id="element-583" data-mp="pu1ni06mbt0r">
                <h2 className="font-bebas text-3xl text-white tracking-wider" data-id="element-584" data-mp="fy87u7xlrjer">
                  PRIVACY POLICY
                </h2>
                <button onClick={() => setShowPrivacyPolicy(false)} className="text-text-dimmed hover:text-acid-green transition-colors" data-id="element-585" data-mp="25e7pkdfaeh60">
                  <X size={24} data-id="element-586" data-mp="3utih4nl3tm1z" />
                </button>
              </div>

              {/* Modal Body */}
              <div className="p-6 overflow-y-auto font-inter text-sm text-text-dimmed leading-relaxed space-y-6 custom-scrollbar" data-id="element-587" data-mp="3pw8gebs9lnyu">
                <p data-id="element-588" data-mp="8g0gj34j57gx">
                  <strong data-id="element-589" data-mp="3nz5fkj3lmsh">Effective Date:</strong> May 18, 2026
                </p>
                <p data-id="element-590" data-mp="3lw6gazywjbm">
                  BLACKOUT UNIT (“BLACKOUT UNIT,” “we,” “our,” or “us”) respects
                  your privacy and is committed to protecting your personal
                  information. This Privacy Policy explains how we collect, use,
                  store, and protect your information when you visit or make a
                  purchase from our website.
                </p>
                <p data-id="element-591" data-mp="mcdsxxu7iioj">
                  By accessing or using our website, you acknowledge and agree
                  to the practices described in this Privacy Policy.
                </p>

                <div data-id="element-592" data-mp="2o7o78gsya3ra">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-593" data-mp="1x40tohdhwsei">
                    INFORMATION WE COLLECT
                  </h3>
                  <p data-id="element-594" data-mp="1t26yuppzeim9">
                    When you visit or interact with our website, we may collect
                    certain information, including but not limited to:
                  </p>
                  <h4 className="font-bold text-white mt-4 mb-2" data-id="element-595" data-mp="1jdf7aiou20bv">
                    Personal Information
                  </h4>
                  <ul className="list-disc pl-5 space-y-1" data-id="element-596" data-mp="1ef3x26umlnt4">
                    <li data-id="element-597" data-mp="19dy4c90yu0jl">Full name</li>
                    <li data-id="element-598" data-mp="19cwirambpvnm">Billing address</li>
                    <li data-id="element-599" data-mp="15cky3xtynvc5">Shipping address</li>
                    <li data-id="element-600" data-mp="15dnom4ndfvrj">Email address</li>
                    <li data-id="element-601" data-mp="10drinzv45u9c">Phone number</li>
                    <li data-id="element-602" data-mp="10et7r88ysha2">Payment information</li>
                    <li data-id="element-603" data-mp="10g49z3mrhgz2">Order history</li>
                  </ul>
                  <h4 className="font-bold text-white mt-4 mb-2" data-id="element-604" data-mp="2zpklwe8hvvui">
                    Technical & Device Information
                  </h4>
                  <ul className="list-disc pl-5 space-y-1" data-id="element-605" data-mp="2upy8a3or8dl6">
                    <li data-id="element-606" data-mp="32aifzh7xsrty">IP address</li>
                    <li data-id="element-607" data-mp="329h45aj3k1b6">Browser type</li>
                    <li data-id="element-608" data-mp="379czkldqakf4">Device type</li>
                    <li data-id="element-609" data-mp="378bowi0mjzxx">Operating system</li>
                    <li data-id="element-610" data-mp="3c0lcvsi6ipxk">Referral URLs</li>
                    <li data-id="element-611" data-mp="3c1wp8gpox60a">Website activity and interaction data</li>
                  </ul>
                  <h4 className="font-bold text-white mt-4 mb-2" data-id="element-612" data-mp="3gzogd8iigo3f">
                    Transaction Information
                  </h4>
                  <ul className="list-disc pl-5 space-y-1" data-id="element-613" data-mp="2jeshi3z7qdkt">
                    <li data-id="element-614" data-mp="2ocbtsyccoga4">Products purchased</li>
                    <li data-id="element-615" data-mp="2tan4fbagyute">Order value</li>
                    <li data-id="element-616" data-mp="2t9kbyyxi0kbd">Payment method</li>
                    <li data-id="element-617" data-mp="2tcq0abyazi61">Shipping details</li>
                  </ul>
                </div>

                <div data-id="element-618" data-mp="2xdjo75bqwwyx">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-619" data-mp="8kejqfxe4b31">
                    HOW WE USE YOUR INFORMATION
                  </h3>
                  <p data-id="element-620" data-mp="ckyg3ha53ao4">We may use collected information to:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-621" data-mp="29mm1sazqgv1i">
                    <li data-id="element-622" data-mp="29ksvwxwy2euk">Process and fulfill orders</li>
                    <li data-id="element-623" data-mp="24oc701hx7wgf">Provide customer support</li>
                    <li data-id="element-624" data-mp="24pn8tvrt2u4w">Send order confirmations and tracking updates</li>
                    <li data-id="element-625" data-mp="2im0pj2oimrib">Prevent fraud and unauthorized transactions</li>
                    <li data-id="element-626" data-mp="2dnz96pih56aj">
                      Improve website functionality and customer experience
                    </li>
                    <li data-id="element-627" data-mp="1pzfyy4fv6jft">Conduct analytics and operational improvements</li>
                    <li data-id="element-628" data-mp="1lxui6807ll0c">Enforce our Terms & Policies</li>
                    <li data-id="element-629" data-mp="1lv8923xo6xg0">
                      Communicate promotional offers or marketing updates (where
                      permitted)
                    </li>
                  </ul>
                </div>

                <div data-id="element-630" data-mp="1785ea50qf2wd">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-631" data-mp="177n5ya0soy83">
                    PAYMENT SECURITY
                  </h3>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-632" data-mp="128an00d1obas">
                    <li data-id="element-633" data-mp="3dvvwft9egs34">
                      BLACKOUT UNIT does not directly store complete payment
                      card information.
                    </li>
                    <li data-id="element-634" data-mp="3ioyv2ft1arq6">
                      Payments are securely processed through third-party
                      payment processors and gateways compliant with industry
                      security standards.
                    </li>
                    <li data-id="element-635" data-mp="1er0u2ttmds4">
                      However, no method of transmission or storage is 100%
                      secure, and BLACKOUT UNIT cannot guarantee absolute
                      security.
                    </li>
                  </ul>
                </div>

                <div data-id="element-636" data-mp="3sl1wfjg2amc2">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-637" data-mp="3skil4lkx2w70">
                    COOKIES & TRACKING TECHNOLOGIES
                  </h3>
                  <p data-id="element-638" data-mp="2c94zdt3gwkay">
                    Our website may use cookies, pixels, analytics tools, and
                    similar technologies to:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-639" data-mp="2wglbz1oijday">
                    <li data-id="element-640" data-mp="2rpbjzufhrxvw">Improve site performance</li>
                    <li data-id="element-641" data-mp="2rns5a89hhuw8">Personalize user experience</li>
                    <li data-id="element-642" data-mp="2nmoqzq7346x4">Analyze website traffic</li>
                    <li data-id="element-643" data-mp="2nldnzslgr372">Support advertising and remarketing campaigns</li>
                  </ul>
                  <p className="mt-2" data-id="element-644" data-mp="2imah02lxamwg">
                    Users may disable cookies through their browser settings;
                    however, portions of the website may not function properly
                    as a result.
                  </p>
                </div>

                <div data-id="element-645" data-mp="36coa7wg8ursm">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-646" data-mp="36c4vsppsyljc">
                    THIRD-PARTY SERVICES
                  </h3>
                  <p data-id="element-647" data-mp="1uyj6n4jy0jxt">
                    We may share information with trusted third-party service
                    providers involved in:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-648" data-mp="1pyeprdf4hn72">
                    <li data-id="element-649" data-mp="1fwu5w2txkkp2">Payment processing</li>
                    <li data-id="element-650" data-mp="1fty9wk1n8639">Shipping and logistics</li>
                    <li data-id="element-651" data-mp="1kvxchrpk6yz5">Website hosting</li>
                    <li data-id="element-652" data-mp="1ksja4jgwaprp">Fraud prevention</li>
                    <li data-id="element-653" data-mp="1ptp1acuwq4z4">Marketing and analytics</li>
                  </ul>
                  <p className="mt-2" data-id="element-654" data-mp="1ukf9dxupwlxi">
                    These third parties receive only the information reasonably
                    necessary to perform their services. BLACKOUT UNIT is not
                    responsible for the independent privacy practices of
                    third-party websites or services.
                  </p>
                </div>

                <div data-id="element-655" data-mp="28idlsxpha8ad">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-656" data-mp="2djjdqtbbdriu">
                    FRAUD PREVENTION & LEGAL COMPLIANCE
                  </h3>
                  <p data-id="element-657" data-mp="e7qpbl2lduhq">
                    We reserve the right to disclose information when necessary
                    to:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-658" data-mp="b4ueueisceqv">
                    <li data-id="element-659" data-mp="b52rc5azxi1j">Comply with legal obligations</li>
                    <li data-id="element-660" data-mp="66j3fzcudw6j">Respond to lawful requests</li>
                    <li data-id="element-661" data-mp="67u964pule0a">Protect BLACKOUT UNIT’s rights or property</li>
                    <li data-id="element-662" data-mp="l3s1fbwnhy78">
                      Prevent fraud, abuse, chargebacks, or unauthorized
                      transactions
                    </li>
                    <li data-id="element-663" data-mp="u3f2fwlgx1zr">Enforce our agreements and policies</li>
                  </ul>
                </div>

                <div data-id="element-664" data-mp="p5563io0bvck">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-665" data-mp="p3u1xhqnglkx">
                    DATA RETENTION
                  </h3>
                  <p data-id="element-666" data-mp="13sqarh0j62ml">
                    We retain customer information only as long as reasonably
                    necessary for:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-667" data-mp="1cteosbpxc2zh">
                    <li data-id="element-668" data-mp="18skzpf0qwi50">Business operations</li>
                    <li data-id="element-669" data-mp="18tw0d5yw99rw">Legal compliance</li>
                    <li data-id="element-670" data-mp="18qrs9xib5tvy">Tax obligations</li>
                    <li data-id="element-671" data-mp="1rhy7nnfsu07u">Fraud prevention</li>
                    <li data-id="element-672" data-mp="1rf27rtke51gr">Dispute resolution</li>
                    <li data-id="element-673" data-mp="1wg7yxmyekgo6">Enforcement of agreements</li>
                  </ul>
                  <p className="mt-2" data-id="element-674" data-mp="1iggr63yhbwim">
                    BLACKOUT UNIT reserves the right to maintain transaction
                    records and related communications for legal and operational
                    purposes.
                  </p>
                </div>

                <div data-id="element-675" data-mp="18oare81zkasv">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-676" data-mp="1dgu3t1oxszw3">
                    MARKETING COMMUNICATIONS
                  </h3>
                  <p data-id="element-677" data-mp="zr0eyjdfmfmd">
                    By providing your email address or phone number, you may
                    receive:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-678" data-mp="prjb87hqqbt1">
                    <li data-id="element-679" data-mp="ps1cxjn69i8c">Order notifications</li>
                    <li data-id="element-680" data-mp="uqcpi24uq6u9">Marketing emails</li>
                    <li data-id="element-681" data-mp="uq2yqcbzfvni">Promotional messages</li>
                    <li data-id="element-682" data-mp="1a8dqr5l46qdh">Product announcements</li>
                  </ul>
                  <p className="mt-2" data-id="element-683" data-mp="1a6jd8cc6a0jf">
                    You may opt out of marketing communications at any time by
                    using the unsubscribe link or contacting support.
                  </p>
                </div>

                <div data-id="element-684" data-mp="w94ics35h0k2">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-685" data-mp="w7t7677dkqix">
                    CHILDREN’S PRIVACY
                  </h3>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-686" data-mp="rb2rvm3e9yyk">
                    <li data-id="element-687" data-mp="mi06w2conxtz">
                      BLACKOUT UNIT does not knowingly collect personal
                      information from individuals under the age of 13.
                    </li>
                    <li data-id="element-688" data-mp="dj65lyoeqja3">
                      If we become aware that information from a minor has been
                      collected, we reserve the right to delete such
                      information.
                    </li>
                  </ul>
                </div>

                <div data-id="element-689" data-mp="2f7sopp3v7r48">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-690" data-mp="2f6hbyzsfz90z">
                    INTERNATIONAL USERS
                  </h3>
                  <p data-id="element-691" data-mp="2k4sndeydxrlb">
                    If you access our website from outside the United States,
                    you acknowledge that your information may be transferred to
                    and processed within the United States.
                  </p>
                </div>

                <div data-id="element-692" data-mp="1wim4tyrc4tgu">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-693" data-mp="1weybazlw4724">
                    NO GUARANTEE OF UNINTERRUPTED SERVICE
                  </h3>
                  <p data-id="element-694" data-mp="25hh8p46wprgz">
                    While we take reasonable measures to protect our systems and
                    customer data, BLACKOUT UNIT does not guarantee that the
                    website or servers will always be secure, uninterrupted, or
                    free from unauthorized access.
                  </p>
                </div>

                <div data-id="element-695" data-mp="1hpsc3bn1ygu8">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-696" data-mp="p6ytqtaf9twr">
                    LIMITATION OF LIABILITY
                  </h3>
                  <p data-id="element-697" data-mp="u4gtpu6goysm">
                    To the fullest extent permitted by law, BLACKOUT UNIT shall
                    not be liable for:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-698" data-mp="13682x907nnr8">
                    <li data-id="element-699" data-mp="134dnubbmepv2">Unauthorized third-party access</li>
                    <li data-id="element-700" data-mp="6h8plfkrrvs6">Cyberattacks</li>
                    <li data-id="element-701" data-mp="6e4hi746ofw8">Data breaches beyond reasonable control</li>
                    <li data-id="element-702" data-mp="ailyjyj5sf3b">Service interruptions</li>
                    <li data-id="element-703" data-mp="fgvq7z5ocxk6">
                      Indirect or consequential damages arising from website use
                    </li>
                  </ul>
                </div>

                <div data-id="element-704" data-mp="k9ozn0c38u2l">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-705" data-mp="3ixm6r7yvut04">
                    POLICY CHANGES
                  </h3>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-706" data-mp="3nvxd38pyyldl">
                    <li data-id="element-707" data-mp="3gd67cx6gg36h">
                      BLACKOUT UNIT reserves the right to modify or update this
                      Privacy Policy at any time without prior notice.
                    </li>
                    <li data-id="element-708" data-mp="36f07el47l749">
                      Changes become effective immediately upon posting to the
                      website.
                    </li>
                  </ul>
                </div>

                <div data-id="element-709" data-mp="2xe227zi1atk3">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-710" data-mp="2xeljrf3rvfxl">
                    CONTACT INFORMATION
                  </h3>
                  <p data-id="element-711" data-mp="2sm0r4gwlr8vn">
                    BLACKOUT UNIT Privacy & Support Department:{' '}
                    <a href="mailto:support@blackoutunit.com" className="text-acid-green hover:underline" data-id="element-712" data-mp="2np20i8c5dk27">
                      support@blackoutunit.com
                    </a>
                  </p>
                </div>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>

      {/* Terms of Service Modal */}
      <AnimatePresence data-id="element-713" data-mp="1zzu380syvkgf">
        {showTermsPolicy && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" data-id="element-714" data-mp="242z2luhr360u">
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} onClick={() => setShowTermsPolicy(false)} className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-715" data-mp="1q3r1ux5xvpuj" />
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} className="relative w-full max-w-3xl max-h-[85vh] bg-dark-1 border border-dark-3 shadow-2xl flex flex-col" data-id="element-716" data-mp="291tj2ps8wihs">
              {/* Modal Header */}
              <div className="flex items-center justify-between p-6 border-b border-dark-3 bg-base-black" data-id="element-717" data-mp="q2cddcuwi4pi">
                <h2 className="font-bebas text-3xl text-white tracking-wider" data-id="element-718" data-mp="13u0opdxbsp5f">
                  TERMS OF SERVICE
                </h2>
                <button onClick={() => setShowTermsPolicy(false)} className="text-text-dimmed hover:text-acid-green transition-colors" data-id="element-719" data-mp="c3ctsjm8wg07">
                  <X size={24} data-id="element-720" data-mp="76mehyi9lofu" />
                </button>
              </div>

              {/* Modal Body */}
              <div className="p-6 overflow-y-auto font-inter text-sm text-text-dimmed leading-relaxed space-y-6 custom-scrollbar" data-id="element-721" data-mp="g4y17pg0g230">
                <p data-id="element-722" data-mp="1wieo9y42btj3">
                  <strong data-id="element-723" data-mp="1whmtuqm7c1ue">Effective Date:</strong> May 18, 2026
                </p>
                <p data-id="element-724" data-mp="1rj38arbiss2k">
                  Welcome to BLACKOUT UNIT. These Terms of Service (“Terms”)
                  govern your access to and use of the BLACKOUT UNIT website,
                  products, services, and related content.
                </p>
                <p data-id="element-725" data-mp="2rv7fw8c8gf6d">
                  By accessing this website or placing an order with BLACKOUT
                  UNIT, you acknowledge that you have read, understood, and
                  agreed to be legally bound by these Terms of Service.
                </p>
                <p data-id="element-726" data-mp="35sm9zqdflb4o">
                  If you do not agree with these Terms, you must not use this
                  website.
                </p>

                <div data-id="element-727" data-mp="3fj8m3alxvjim">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-728" data-mp="3fip2zqkjyp30">
                    1. GENERAL CONDITIONS
                  </h3>
                  <p data-id="element-729" data-mp="3kha3lr3pvarz">
                    BLACKOUT UNIT reserves the right to refuse service to
                    anyone, at any time, for any reason, including but not
                    limited to:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-730" data-mp="3tgdrd8dtwect">
                    <li data-id="element-731" data-mp="1hwxzinzffrw1">Suspected fraud</li>
                    <li data-id="element-732" data-mp="1du1buiv155l8">Abuse of policies</li>
                    <li data-id="element-733" data-mp="1dszxa4et20yr">Chargeback abuse</li>
                    <li data-id="element-734" data-mp="18uos46zggemv">Harassment or threatening conduct</li>
                    <li data-id="element-735" data-mp="18v86xett6mwo">Unauthorized resale activity</li>
                    <li data-id="element-736" data-mp="13w51vudtwgop">Violations of these Terms</li>
                  </ul>
                  <p className="mt-2" data-id="element-737" data-mp="21jdue9c8yq07">
                    We reserve the right to limit, cancel, or refuse orders at
                    our sole discretion.
                  </p>
                </div>

                <div data-id="element-738" data-mp="1rtkj79g0ocwh">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-739" data-mp="1rssn7xiicd5o">
                    2. ELIGIBILITY
                  </h3>
                  <p data-id="element-740" data-mp="1mtobp08423c6">By using this website, you represent that:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-741" data-mp="2kadfv0kj9hoq">
                    <li data-id="element-742" data-mp="2kboiuy65mles">
                      You are at least 18 years old or have permission from a
                      legal guardian
                    </li>
                    <li data-id="element-743" data-mp="dm4o7e06zhs4">All information provided is accurate and complete</li>
                    <li data-id="element-744" data-mp="hng8d40arasx">
                      You are legally authorized to use the selected payment
                      method
                    </li>
                  </ul>
                </div>

                <div data-id="element-745" data-mp="8tuq3aoxbber">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-746" data-mp="8tbl0ukdghi5">
                    3. PRODUCTS & AVAILABILITY
                  </h3>
                  <p data-id="element-747" data-mp="3v231za606b9m">BLACKOUT UNIT reserves the right to:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-748" data-mp="3v3nuku8rbk4u">
                    <li data-id="element-749" data-mp="3h33dq3mejydz">Modify products</li>
                    <li data-id="element-750" data-mp="3h464mbjq60tw">Change pricing</li>
                    <li data-id="element-751" data-mp="3m0wfmkgoa68g">Discontinue items</li>
                    <li data-id="element-752" data-mp="3m1odk1xqsg1w">Limit quantities</li>
                    <li data-id="element-753" data-mp="1fb85xz39oe11">Correct pricing or listing errors</li>
                  </ul>
                  <p className="mt-2" data-id="element-754" data-mp="1ka1i9o6thyzm">without prior notice.</p>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-755" data-mp="1k9jem6htsiho">
                    <li data-id="element-756" data-mp="1ud6uqiurkacu">
                      All product availability is subject to inventory and
                      operational limitations.
                    </li>
                    <li data-id="element-757" data-mp="236a4oh67a52q">
                      We do not guarantee that product descriptions, images,
                      colors, or specifications will appear exactly the same
                      across all devices or displays.
                    </li>
                  </ul>
                </div>

                <div data-id="element-758" data-mp="285d6ztuspx70">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-759" data-mp="286692hit7yit">
                    4. ORDER ACCEPTANCE
                  </h3>
                  <p data-id="element-760" data-mp="2m4mg69kl3r1h">
                    An order confirmation does not constitute final acceptance
                    of an order.
                  </p>
                  <p className="mt-2" data-id="element-761" data-mp="rqlezi1kary8">BLACKOUT UNIT reserves the right to:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-762" data-mp="npjfd03qgdvq">
                    <li data-id="element-763" data-mp="nr4d0ylcgcxt">Refuse or cancel orders</li>
                    <li data-id="element-764" data-mp="1cazqqqri2cg8">Limit quantities purchased</li>
                    <li data-id="element-765" data-mp="1ca7xvnpaestn">Reject suspicious transactions</li>
                    <li data-id="element-766" data-mp="1h8rldsjj4co4">Request additional verification</li>
                  </ul>
                  <p className="mt-2" data-id="element-767" data-mp="1lzresntfwclv">
                    Orders may be canceled for reasons including:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-768" data-mp="1q0tiphyaxcu6">
                    <li data-id="element-769" data-mp="tbvl7rz630tb">Fraud prevention</li>
                    <li data-id="element-770" data-mp="td6n1m91xyhs">Payment authorization failure</li>
                    <li data-id="element-771" data-mp="ya6tvzdq759y">Inventory shortages</li>
                    <li data-id="element-772" data-mp="yayr1emz1b2c">Pricing inaccuracies</li>
                    <li data-id="element-773" data-mp="12bsey80eypv8">Operational concerns</li>
                  </ul>
                </div>

                <div data-id="element-774" data-mp="17b526tv75yyc">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-775" data-mp="17bn2q2ow6zc2">
                    5. PRICING & PAYMENT
                  </h3>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-776" data-mp="2dr7b59kstdpa">
                    <li data-id="element-777" data-mp="2ipiklj76lm6z">All prices displayed are in U.S. Dollars (USD).</li>
                    <li data-id="element-778" data-mp="2su7ck28ym4kx">
                      Customers agree to pay all charges associated with their
                      order, including: Product costs, Shipping fees, Taxes, and
                      Applicable processing fees.
                    </li>
                    <li data-id="element-779" data-mp="2j2uhl1rv6yao">
                      By submitting payment, the customer authorizes BLACKOUT
                      UNIT and its payment processors to charge the selected
                      payment method.
                    </li>
                    <li data-id="element-780" data-mp="254d21rc44s3u">
                      Failure to successfully process payment may result in
                      order cancellation.
                    </li>
                  </ul>
                </div>

                <div data-id="element-781" data-mp="1w4zr0u8cbvh0">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-782" data-mp="1w5j5g0ys81qa">
                    6. SHIPPING & DELIVERY
                  </h3>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-783" data-mp="3uhhvfu7nxkwe">
                    <li data-id="element-784" data-mp="3qiqx5jrgnx7p">
                      Shipping timelines provided are estimates only and are not
                      guaranteed.
                    </li>
                    <li data-id="element-785" data-mp="fo75k77r9dx5">
                      BLACKOUT UNIT is not responsible for delays caused by:
                      USPS or shipping carriers, Weather, Customs, Operational
                      disruptions, or Incorrect customer information.
                    </li>
                    <li data-id="element-786" data-mp="qewnxwprnrx">
                      Risk of loss transfers to the customer once the package
                      has been transferred to the shipping carrier.
                    </li>
                    <li data-id="element-787" data-mp="aoktw27ks5qg">
                      Customers are responsible for providing accurate shipping
                      information.
                    </li>
                  </ul>
                </div>

                <div data-id="element-788" data-mp="1m3hl9ir8f70z">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-789" data-mp="1m2yemy718529">
                    7. RETURNS, EXCHANGES & FINAL SALE ITEMS
                  </h3>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-790" data-mp="1h70xipny2uof">
                    <li data-id="element-791" data-mp="2z1i1hf5uagrk">
                      Due to the nature of our products, promotional pricing,
                      limited releases, tactical gear, and hygiene-sensitive
                      merchandise, many products sold by BLACKOUT UNIT are
                      considered Final Sale.
                    </li>
                    <li data-id="element-792" data-mp="2v2sjtadrqd24">
                      Customers agree to review our Returns & Exchanges Policy
                      prior to purchase.
                    </li>
                    <li data-id="element-793" data-mp="3mqkm8vvrspqa">Original shipping costs are non-refundable.</li>
                    <li data-id="element-794" data-mp="390z6dud9oqmh">
                      If a return is exceptionally approved, the customer is
                      responsible for all return shipping costs and return
                      labels.
                    </li>
                  </ul>
                </div>

                <div data-id="element-795" data-mp="aagyz25tojtb">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-796" data-mp="aapbuu1y3p4i">
                    8. WARRANTY DISCLAIMER
                  </h3>
                  <p data-id="element-797" data-mp="k5xnw4n0d5ky">
                    Except where expressly stated, all products are sold “AS IS”
                    and “AS AVAILABLE.”
                  </p>
                  <p className="mt-2" data-id="element-798" data-mp="a7gtexov28u5">
                    BLACKOUT UNIT disclaims all warranties, express or implied,
                    including but not limited to:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-799" data-mp="183hzzh6fa6s">
                    <li data-id="element-800" data-mp="19ekzx2ssdwu">Merchantability</li>
                    <li data-id="element-801" data-mp="3slzds1e9748g">Fitness for a particular purpose</li>
                    <li data-id="element-802" data-mp="3skeoaq6sqbhg">Non-infringement</li>
                  </ul>
                  <p className="mt-2" data-id="element-803" data-mp="3nno3xqnyktq8">
                    We do not guarantee uninterrupted, error-free, or
                    defect-free operation of the website or products.
                  </p>
                </div>

                <div data-id="element-804" data-mp="3dqt9pjypxfhr">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-805" data-mp="39nn7cneq88gk">
                    9. USER CONDUCT
                  </h3>
                  <p data-id="element-806" data-mp="1p4b1ft2us7hb">Customers and users agree not to:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-807" data-mp="1t6xufxb9fyg3">
                    <li data-id="element-808" data-mp="1t54nsi0nde83">Use the website unlawfully</li>
                    <li data-id="element-809" data-mp="1y5j04c9a7abx">Commit fraud</li>
                    <li data-id="element-810" data-mp="1y6kcql5y44vr">Abuse refund or chargeback systems</li>
                    <li data-id="element-811" data-mp="235dnw6xrfjsr">Interfere with website operations</li>
                    <li data-id="element-812" data-mp="232rgq8es76b2">Upload malicious code</li>
                    <li data-id="element-813" data-mp="15ienbl3y5rpl">Impersonate others</li>
                    <li data-id="element-814" data-mp="15fiqk03u592q">Harass or threaten BLACKOUT UNIT staff</li>
                  </ul>
                  <p className="mt-2" data-id="element-815" data-mp="1aedjhuvioe0k">
                    Violation of these Terms may result in account termination,
                    order cancellation, legal action, or refusal of future
                    service.
                  </p>
                </div>

                <div data-id="element-816" data-mp="mq2mj2sxyyhk">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-817" data-mp="mqlw9w8fugki">
                    10. INTELLECTUAL PROPERTY
                  </h3>
                  <p data-id="element-818" data-mp="2teuuk1nabeq3">
                    All website content, including but not limited to: Logos,
                    Branding, Product designs, Images, Graphics, Text, Videos,
                    and Marketing materials is the exclusive property of
                    BLACKOUT UNIT and may not be copied, reproduced, modified,
                    or distributed without written permission.
                  </p>
                </div>

                <div data-id="element-819" data-mp="3d1shs8jnc6ww">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-820" data-mp="3d581joo9m44n">
                    11. LIMITATION OF LIABILITY
                  </h3>
                  <p data-id="element-821" data-mp="3m4bm6x32yrl9">
                    To the fullest extent permitted by law, BLACKOUT UNIT shall
                    not be liable for:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-822" data-mp="3h2m5p1x39lps">
                    <li data-id="element-823" data-mp="1rqk2f4r1erc3">Indirect damages</li>
                    <li data-id="element-824" data-mp="1rrloe49lcy8l">Consequential damages</li>
                    <li data-id="element-825" data-mp="1mrzdw2l5dw3h">Lost profits</li>
                    <li data-id="element-826" data-mp="1mt22u4ywtogr">Delayed shipments</li>
                    <li data-id="element-827" data-mp="28didls55pz2">Carrier issues</li>
                    <li data-id="element-828" data-mp="2aq6yhsemyl3">Data loss</li>
                    <li data-id="element-829" data-mp="789l7hp3rbd1">Unauthorized access</li>
                    <li data-id="element-830" data-mp="76yhfhvnq3lx">Product misuse</li>
                  </ul>
                  <p className="mt-2" data-id="element-831" data-mp="3pmisfyejtu32">
                    BLACKOUT UNIT’s total liability shall never exceed the
                    amount paid for the product purchased.
                  </p>
                </div>

                <div data-id="element-832" data-mp="3fmrz401q5l4k">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-833" data-mp="3fm8hkkfzkyr2">
                    12. CHARGEBACKS & PAYMENT DISPUTES
                  </h3>
                  <p data-id="element-834" data-mp="36ndbr9gutqoa">
                    Customers agree not to initiate false, abusive, or
                    fraudulent chargebacks.
                  </p>
                  <p className="mt-2" data-id="element-835" data-mp="3aqjew88o71qj">
                    By completing a purchase, the customer acknowledges that:
                  </p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-836" data-mp="18xlmuempwd6n">
                    <li data-id="element-837" data-mp="18ur4csn9l2fv">Product descriptions were reviewed</li>
                    <li data-id="element-838" data-mp="2hutqb7t8uzw7">Policies were accepted</li>
                    <li data-id="element-839" data-mp="2cv796naaozi4">Shipping and processing timelines were disclosed</li>
                    <li data-id="element-840" data-mp="2cx1tbzdqsnl5">The transaction was authorized</li>
                  </ul>
                  <p className="mt-2" data-id="element-841" data-mp="28tm1rhgj5dfb">
                    BLACKOUT UNIT reserves the right to dispute invalid
                    chargebacks using: Tracking information, Order records, IP
                    logs, Customer communications, Proof of delivery, and Policy
                    acceptance records.
                  </p>
                  <p className="mt-2" data-id="element-842" data-mp="2rs81arweewh4">Fraudulent disputes may result in:</p>
                  <ul className="list-disc pl-5 space-y-1 mt-2" data-id="element-843" data-mp="2rq3pzow66v6t">
                    <li data-id="element-844" data-mp="2ms246w7d0hrn">Permanent refusal of service</li>
                    <li data-id="element-845" data-mp="3k8iscvsd4aos">Collections activity</li>
                    <li data-id="element-846" data-mp="3k9aoc7pvgafl">Legal action where permitted</li>
                  </ul>
                </div>

                <div data-id="element-847" data-mp="3fh0tcd9wgk6g">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-848" data-mp="3ffpmu5p2kybn">
                    13. FORCE MAJEURE
                  </h3>
                  <p data-id="element-849" data-mp="3rrs0klp4u3c9">
                    BLACKOUT UNIT shall not be liable for delays or failure to
                    perform caused by circumstances beyond reasonable control,
                    including but not limited to: Natural disasters, Carrier
                    disruptions, Cyberattacks, Government actions, Supply chain
                    interruptions, Labor shortages, or Power outages.
                  </p>
                </div>

                <div data-id="element-850" data-mp="ejxd90gejtck">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-851" data-mp="ej5ghmb2jpkp">
                    14. GOVERNING LAW
                  </h3>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-852" data-mp="obtc4dqbbnhu">
                    <li data-id="element-853" data-mp="od4f4bbxor7w">
                      These Terms shall be governed and interpreted under the
                      laws of the State of Florida, United States, without
                      regard to conflict of law principles.
                    </li>
                    <li data-id="element-854" data-mp="1ilmzzio77hza">
                      Any dispute arising from these Terms shall be resolved
                      exclusively in the appropriate courts located within the
                      State of Florida.
                    </li>
                  </ul>
                </div>

                <div data-id="element-855" data-mp="1nn2pbmxesanh">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-856" data-mp="1nmklo58f2u5j">
                    15. SEVERABILITY
                  </h3>
                  <p data-id="element-857" data-mp="uxdkszlhpsh4">
                    If any provision of these Terms is found unenforceable or
                    invalid, the remaining provisions shall remain in full force
                    and effect.
                  </p>
                </div>

                <div data-id="element-858" data-mp="14urrw8lix4wr">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-859" data-mp="14tgklysvdf0w">
                    16. MODIFICATIONS TO TERMS
                  </h3>
                  <ul className="list-disc pl-5 space-y-2 mt-2" data-id="element-860" data-mp="c7dzmnsrsxiz">
                    <li data-id="element-861" data-mp="c51ksjib73a5">
                      BLACKOUT UNIT reserves the right to modify these Terms of
                      Service at any time without prior notice.
                    </li>
                    <li data-id="element-862" data-mp="2sn0x0zvnoth6">
                      Continued use of the website following changes constitutes
                      acceptance of the revised Terms.
                    </li>
                  </ul>
                </div>

                <div data-id="element-863" data-mp="36kyyj4ovovf9">
                  <h3 className="font-bebas text-xl text-white mb-2" data-id="element-864" data-mp="36lqsyc6qon3y">
                    17. CONTACT INFORMATION
                  </h3>
                  <p data-id="element-865" data-mp="3bj0nu7cwdqz6">
                    BLACKOUT UNIT Support Department:{' '}
                    <a href="mailto:support@blackoutunit.com" className="text-acid-green hover:underline" data-id="element-866" data-mp="2xjhjlpn7izs5">
                      support@blackoutunit.com
                    </a>
                  </p>
                </div>
              </div>
            </motion.div>
          </div>}
      </AnimatePresence>

      {/* Top Section */}
      <div className="container mx-auto px-6 md:px-12 py-[80px] pb-[60px]" data-id="element-867" data-mp="2zorf3pdhm4a4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12" data-id="element-868" data-mp="33sz47nnuxm8v">
          {/* Col 1 - Brand */}
          <div data-id="element-869" data-mp="2ptg7dr0hxxbv">
            <div className="flex items-center gap-3 mb-3" data-id="element-870" data-mp="2ptzesdsit3bn">
              <img src="https://cdn.magicpatterns.com/uploads/gtew43sgjbWAUi8V7My12k/hf_20260505_154603_f5f185ee-8480-4693-8c47-91f27540bf0d.png" alt="Blackout Unit Logo" className="w-14 h-14 object-contain" data-id="element-871" data-mp="2uqg5nfr3tvsf" />
              <div data-id="element-872" data-mp="38r0qehgky1ok">
                <div className="font-bebas text-2xl tracking-wider text-white leading-none" data-id="element-873" data-mp="38rsk1mqm9pc7">
                  BLACKOUT <span className="text-acid-green" data-id="element-874" data-mp="3dpbvkevxjo0g">UNIT™</span>
                </div>
                <div className="font-barlow font-bold text-[9px] text-acid-green tracking-[3px] uppercase mt-1" data-id="element-875" data-mp="59s7rve12xss">
                  EST. 2019
                </div>
              </div>
            </div>
            <div className="font-barlow text-sm text-white tracking-widest uppercase mb-6" data-id="element-876" data-mp="1uqw57immwivp">
              Built by Operators. For Operators.
            </div>
            <p className="font-inter text-xs text-text-dimmed leading-relaxed mb-6 pr-4" data-id="element-877" data-mp="1pq8g52hyuc44">
              "We spent two years building the mask the industry refused to
              make. This is it. No compromises. No cheap materials. No apologies
              for the standard we hold."
            </p>
            <div className="flex gap-3" data-id="element-878" data-mp="1bunxm865fvx8">
              {['IG', 'TT', 'YT', 'FB', 'X'].map(social => <a key={social} href="#" className="w-8 h-8 bg-dark-1 border border-dark-3 flex items-center justify-center text-xs font-barlow text-text-dimmed hover:text-acid-green hover:border-acid-green transition-colors" data-id="element-879" data-mp="16vtet686m7d4">
                  {social}
                </a>)}
            </div>
          </div>

          {/* Col 2 - Arsenal */}
          <div data-id="element-880" data-mp="1owfd14myvjq8">
            <h4 className="font-bebas text-xl text-white mb-6" data-id="element-881" data-mp="1ouuivg4ke2sw">ARSENAL</h4>
            <ul className="space-y-3 font-inter text-sm text-text-dimmed" data-id="element-882" data-mp="1tuqofjswu2ak">
              <li data-id="element-883" data-mp="1twtnetc1j5rf">
                <button onClick={() => document.getElementById('the-mask')?.scrollIntoView({
                behavior: 'smooth'
              })} className="hover:text-acid-green transition-colors text-left" data-id="element-884" data-mp="1xwu2mg6yrkzj">
                  Ultimate Mask
                </button>
              </li>
              <li data-id="element-885" data-mp="1f62xjqu0egqy">
                <button onClick={() => document.getElementById('the-mask')?.scrollIntoView({
                behavior: 'smooth'
              })} className="hover:text-acid-green transition-colors text-left" data-id="element-886" data-mp="1f5kplwxzie37">
                  Individual Lens Packs
                </button>
              </li>
              <li data-id="element-887" data-mp="jxiu0yynrlwq">
                <button onClick={() => document.getElementById('the-mask')?.scrollIntoView({
                behavior: 'smooth'
              })} className="hover:text-acid-green transition-colors text-left" data-id="element-888" data-mp="jvy09bk646zx">
                  The Ghost Bundle
                </button>
              </li>
              <li data-id="element-889" data-mp="yeklp37fq4j">
                <button onClick={() => document.getElementById('the-mask')?.scrollIntoView({
                behavior: 'smooth'
              })} className="hover:text-acid-green transition-colors text-left" data-id="element-890" data-mp="ywon7w3z8n0">
                  The Operator Bundle
                </button>
              </li>
              <li data-id="element-891" data-mp="3ebq47dovgmlo">
                <button onClick={() => document.getElementById('the-mask')?.scrollIntoView({
                behavior: 'smooth'
              })} className="hover:text-acid-green transition-colors text-left" data-id="element-892" data-mp="3ec86os24nx21">
                  The Squad Bundle
                </button>
              </li>
            </ul>
          </div>

          {/* Col 3 - Support */}
          <div data-id="element-893" data-mp="18ja4ueqm37pc">
            <h4 className="font-bebas text-xl text-white mb-6" data-id="element-894" data-mp="18iscvuazffn8">SUPPORT</h4>
            <ul className="space-y-3 font-inter text-sm text-text-dimmed" data-id="element-895" data-mp="tmazyyn59syk">
              <li data-id="element-896" data-mp="ylw3lmd9ephm">
                <a href="#" className="hover:text-acid-green transition-colors" data-id="element-897" data-mp="ymfbea973xhx">
                  FAQ
                </a>
              </li>
              <li data-id="element-898" data-mp="knpf2wu7a1um">
                <button onClick={e => {
                e.preventDefault();
                setShowShippingPolicy(true);
              }} className="hover:text-acid-green transition-colors text-left" data-id="element-899" data-mp="ko7eg2c5sw6r">
                  Shipping Info
                </button>
              </li>
              <li data-id="element-900" data-mp="2u2dwzw48r3cr">
                <button onClick={e => {
                e.preventDefault();
                setShowWarrantyPolicy(true);
              }} className="hover:text-acid-green transition-colors text-left" data-id="element-901" data-mp="2u3yqrjiqei9k">
                  Warranty Policy
                </button>
              </li>
              <li data-id="element-902" data-mp="2y2xs6u597ww9">
                <button onClick={e => {
                e.preventDefault();
                setShowReturnsPolicy(true);
              }} className="hover:text-acid-green transition-colors text-left" data-id="element-903" data-mp="3cteuefppqqu7">
                  Returns & Exchanges
                </button>
              </li>
              <li data-id="element-904" data-mp="3ht9ikbi3t2bk">
                <button onClick={e => {
                e.preventDefault();
                setShowContactPolicy(true);
              }} className="hover:text-acid-green transition-colors text-left" data-id="element-905" data-mp="3hqnc6f6y8sux">
                  Contact Us
                </button>
              </li>
              <li className="pt-2" data-id="element-906" data-mp="3ri1sem9pntio">
                <a href="tel:+13055550142" className="text-acid-green font-bebas text-lg tracking-wider" data-id="element-907" data-mp="3rj3hhunkagje">
                  +1 (305) 555-0142
                </a>
              </li>
              <li className="pt-2" data-id="element-908" data-mp="590mmmertyn3">
                <address className="not-italic text-text-dimmed leading-relaxed" data-id="element-909" data-mp="9dqhq91lv96y">
                  4531 Madison Industrial Lane, Unit 4531
                  <br data-id="element-910" data-mp="ea8kj3ddkxgn" />
                  Tampa, FL 33605, USA
                </address>
              </li>
            </ul>
          </div>

          {/* Col 4 - Company */}
          <div data-id="element-911" data-mp="o0th6l9hnrwx">
            <h4 className="font-bebas text-xl text-white mb-6" data-id="element-912" data-mp="o1blm56b1cfx">COMPANY</h4>
            <ul className="space-y-3 font-inter text-sm text-text-dimmed" data-id="element-913" data-mp="t1z94gvbrb5e">
              <li data-id="element-914" data-mp="x29mwfpcz5ut">
                <button onClick={e => {
                e.preventDefault();
                setShowMission(true);
              }} className="hover:text-acid-green transition-colors text-left" data-id="element-915" data-mp="x3kt0m6a0pp3">
                  Our Mission
                </button>
              </li>
              <li data-id="element-916" data-mp="28k5lxc9mlmul">
                <button onClick={e => {
                e.preventDefault();
                setShowWhyWeBuilt(true);
              }} className="hover:text-acid-green transition-colors text-left" data-id="element-917" data-mp="28lqe4v8gwtpa">
                  Why We Built This
                </button>
              </li>
              <li data-id="element-918" data-mp="2rhzp39o2p452">
                <button onClick={e => {
                e.preventDefault();
                setShowWholesale(true);
              }} className="hover:text-acid-green transition-colors text-left" data-id="element-919" data-mp="2rhghals4zw4r">
                  For Teams & Wholesale
                </button>
              </li>
              <li data-id="element-920" data-mp="2nkr9pz1wfggo">
                <button onClick={e => {
                e.preventDefault();
                setShowPrivacyPolicy(true);
              }} className="hover:text-acid-green transition-colors text-left" data-id="element-921" data-mp="2nk96gigtk1z9">
                  Privacy Policy
                </button>
              </li>
              <li data-id="element-922" data-mp="2im7l1qvx7qkm">
                <button onClick={e => {
                e.preventDefault();
                setShowTermsPolicy(true);
              }} className="hover:text-acid-green transition-colors text-left" data-id="element-923" data-mp="2ijlik5nw0199">
                  Terms of Service
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-black/50 py-5 px-6 md:px-12 border-t border-dark-3 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-924" data-mp="1lvf8h3874gnl">
        <div className="font-inter text-xs text-text-dimmed text-center md:text-left flex items-center gap-2 flex-wrap justify-center" data-id="element-925" data-mp="1qv9vuwsrio3w">
          <span data-id="element-926" data-mp="1ifklcie81ukf">
            © 2025 BLACKOUT UNIT™ | blackoutunit.com | All Rights Reserved
          </span>
          <FlagIcon className="w-4 h-3" data-id="element-927" data-mp="1ee8ygkmqfnfx" />
        </div>
        <div className="flex gap-2" data-id="element-928" data-mp="1sacn7yeu73l0">
          {['VISA', 'MC', 'AMEX', 'PAYPAL', 'SHOP PAY', 'APPLE PAY'].map(pay => <div key={pay} className="bg-dark-1 border border-dark-3 px-2 py-1 text-[9px] font-barlow text-text-dimmed rounded-sm" data-id="element-929" data-mp="1narnvmvr8t7r">
                {pay}
              </div>)}
        </div>
      </div>

      {/* Our Mission Modal */}
      {showMission && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" data-id="element-930" data-mp="14lkyjh0gh3cz">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={() => setShowMission(false)} className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-931" data-mp="gw8qikgv71c9" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="relative w-full max-w-3xl max-h-[85vh] bg-dark-1 border border-dark-3 shadow-2xl flex flex-col" data-id="element-932" data-mp="31ahsqs7o67ap">
            <div className="flex items-center justify-between p-6 border-b border-dark-3 bg-base-black" data-id="element-933" data-mp="3f2fw0mep98yy">
              <h2 className="font-bebas text-3xl text-white tracking-wider" data-id="element-934" data-mp="3b142i5spg3lh">
                OUR MISSION
              </h2>
              <button onClick={() => setShowMission(false)} className="text-text-dimmed hover:text-acid-green transition-colors" data-id="element-935" data-mp="23pn2b62cmag9">
                <X size={24} data-id="element-936" data-mp="f5ziriwj59f1" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto font-inter text-sm text-text-dimmed leading-relaxed space-y-6 custom-scrollbar" data-id="element-937" data-mp="j5ro7mqmmzg6">
              <p data-id="element-938" data-mp="o3ta0ffftcvc">
                Our mission is simple: build the most aggressive, best-looking
                mask on the planet — and make it accessible to everyone. Not
                just collectors, not just insiders. Everyone.
              </p>
              <p data-id="element-939" data-mp="12u0ko8z7drlh">
                We obsess over every detail so you don't have to settle for the
                cheap, flimsy versions flooding the market. Every BLACKOUT UNIT
                mask is engineered to look like it came straight off a film set
                and hold up to real, everyday use.
              </p>
              <p data-id="element-940" data-mp="38oabaxm0cbpp">
                We're here to give you a piece of gear you'll actually be proud
                to wear — whether that's on the field, at a convention, on the
                bike, or on camera.
              </p>
            </div>
          </motion.div>
        </div>}

      {/* Why We Built This Modal */}
      {showWhyWeBuilt && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" data-id="element-941" data-mp="tsi3za3xsmkr">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={() => setShowWhyWeBuilt(false)} className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-942" data-mp="tq5fee3obdyq" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="relative w-full max-w-3xl max-h-[85vh] bg-dark-1 border border-dark-3 shadow-2xl flex flex-col" data-id="element-943" data-mp="1chy59zng4j28">
            <div className="flex items-center justify-between p-6 border-b border-dark-3 bg-base-black" data-id="element-944" data-mp="263iiznqt6rda">
              <h2 className="font-bebas text-3xl text-white tracking-wider" data-id="element-945" data-mp="1r6hoxdl5akbn">
                WHY WE BUILT THIS
              </h2>
              <button onClick={() => setShowWhyWeBuilt(false)} className="text-text-dimmed hover:text-acid-green transition-colors" data-id="element-946" data-mp="1w386k5cllnz6">
                <X size={24} data-id="element-947" data-mp="1n5673u8ij3e0" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto font-inter text-sm text-text-dimmed leading-relaxed space-y-6 custom-scrollbar" data-id="element-948" data-mp="18fgqqrrumst5">
              <p data-id="element-949" data-mp="1dfcv4s4gkm98">
                We got tired of buying masks that looked incredible in photos
                and fell apart in person — foggy lenses, straps that snapped,
                padding that flattened after a week.
              </p>
              <p data-id="element-950" data-mp="13hyh0z60c9k3">
                So we set out to build the version we always wanted: a mask with
                a genuinely aggressive design, interchangeable lenses, and
                materials chosen for comfort and durability, not just for the
                product shot.
              </p>
              <p data-id="element-951" data-mp="mkrn9qsz3ruk">
                Everything you see on this page — the shell, the lens system,
                the strap, the finish — exists because we were never satisfied
                with what was already out there.
              </p>
            </div>
          </motion.div>
        </div>}

      {/* For Teams & Wholesale Modal */}
      {showWholesale && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6" data-id="element-952" data-mp="3os0cueurehu">
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={() => setShowWholesale(false)} className="absolute inset-0 bg-black/80 backdrop-blur-sm" data-id="element-953" data-mp="3uw49qn9hunn7" />
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="relative w-full max-w-3xl max-h-[85vh] bg-dark-1 border border-dark-3 shadow-2xl flex flex-col" data-id="element-954" data-mp="25lsg9eae5gy4">
            <div className="flex items-center justify-between p-6 border-b border-dark-3 bg-base-black" data-id="element-955" data-mp="1morcfwskpmvr">
              <h2 className="font-bebas text-3xl text-white tracking-wider" data-id="element-956" data-mp="1wl44yrcdtuox">
                FOR TEAMS & WHOLESALE
              </h2>
              <button onClick={() => setShowWholesale(false)} className="text-text-dimmed hover:text-acid-green transition-colors" data-id="element-957" data-mp="331zbbhf1ymlc">
                <X size={24} data-id="element-958" data-mp="2ibvgtadwhflo" />
              </button>
            </div>
            <div className="p-6 overflow-y-auto font-inter text-sm text-text-dimmed leading-relaxed space-y-6 custom-scrollbar" data-id="element-959" data-mp="2ie86k9pwgu9a">
              <p data-id="element-960" data-mp="2sa1jvvbg0rs4">
                Outfitting a full airsoft team, a store, a content house, or an
                event crew? We offer bulk and wholesale pricing for larger
                orders.
              </p>
              <div data-id="element-961" data-mp="1zkukyv82u06c">
                <h3 className="font-bebas text-xl text-white mb-2" data-id="element-962" data-mp="1zmff4jqhbh3o">
                  GET IN TOUCH
                </h3>
                <ul className="list-disc pl-5 space-y-1" data-id="element-963" data-mp="1uoduvvhbhbqm">
                  <li data-id="element-964" data-mp="29bp4hrtxulo3">
                    <strong data-id="element-965" data-mp="29d0alyauw5id">Email:</strong>{' '}
                    <a href="mailto:business@blackoutunit.com" className="text-acid-green hover:underline" data-id="element-966" data-mp="24l0fcj5qe0s4">
                      business@blackoutunit.com
                    </a>
                  </li>
                  <li data-id="element-967" data-mp="1bvt8mww4i4vs">
                    <strong data-id="element-968" data-mp="3njevbrhhoi62">Phone:</strong>{' '}
                    <a href="tel:+13055550142" className="text-acid-green hover:underline" data-id="element-969" data-mp="3nimxea0f68cm">
                      +1 (305) 555-0142
                    </a>
                  </li>
                </ul>
              </div>
              <p data-id="element-970" data-mp="3ijk57q5jfwm2">
                Tell us the quantity you're after and how you plan to use the
                masks, and our team will put together a custom quote and lead
                time for you.
              </p>
            </div>
          </motion.div>
        </div>}
    </footer>;
};